import * as React from 'react';
import styled from '@emotion/styled';

const StyledNotFound = styled.div`
  display: flex;
  flex: 1;
`;

const NotFound = () => (
  <StyledNotFound>
    <h3>Page not Found</h3>
  </StyledNotFound>
);

export default NotFound;
